import gql from 'graphql-tag';

import { executeGqlMutation } from 'src/graphql/client';
import { getSingleProp } from 'src/lib/graphql';
import type {
  BackendContinuousOptimizationVariant,
  BackendMutationCreateContinuousOptimizationVariantArgs,
} from 'src/types/backend';

import { FRAGMENT_CO_VARIANT } from './schema';

const MUTATION = gql`
  mutation CreateCOVariant(
    $landingPageAssetId: ID!
    $htmlText: String!
    $variationId: ID
    $screenshotId: ID
    $isCustom: Boolean
  ) {
    createContinuousOptimizationVariant(
      landingPageAssetId: $landingPageAssetId
      htmlText: $htmlText
      variationId: $variationId
      screenshotId: $screenshotId
      isCustom: $isCustom
    ) {
      ...ContinuousOptimizationVariant
    }
  }
  ${FRAGMENT_CO_VARIANT}
`;

type Variables = BackendMutationCreateContinuousOptimizationVariantArgs;
type Result = BackendContinuousOptimizationVariant;

export const createCOVariant = async (variables: Variables) => {
  const result = await executeGqlMutation({
    mutation: MUTATION,
    variables,
  });

  return getSingleProp<Result>(result.data);
};
